module.exports = __webpack_public_path__ + "img/Beginner-2.8fda8de8.png";